import { CaLabeling, ProductUpdate } from '~/Api/User/ProductGroup/CaLabeling';

export enum ActionTypes {
	request = 'CaLabeling.request',
	receive = 'CaLabeling.receive',
	requestUpdate = 'CaLabeling.requestUpdate',
	receiveUpdate = 'CaLabeling.receiveUpdate',
	scheduleUpdate = 'CaLabeling.scheduleUpdate',
	prune = 'CaLabeling.prune',
}

export interface RequestAction {
	groupId: string;
	request: Promise<any>;
	type: ActionTypes.request;
}

export interface ReceiveAction {
	groupId: string;
	caLabeling: CaLabeling | null;
	request: Promise<any>;
	type: ActionTypes.receive;
}

export interface ScheduleUpdateAction {
	basketVersion: string;
	groupId: string;
	products: ProductUpdate[];
	timeoutId: NodeJS.Timeout;
	type: ActionTypes.scheduleUpdate;
}

export interface RequestUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionTypes.requestUpdate;
}

export interface ReceiveUpdateAction {
	groupId: string;
	caLabeling: CaLabeling | null;
	request: Promise<any>;
	type: ActionTypes.receiveUpdate;
}

export interface PruneAction {
	groupId: string;
	type: ActionTypes.prune;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| ScheduleUpdateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| PruneAction;
